import { defineFurniture } from './types.js';
import type { FurnitureDef } from './types.js';

/**
 * Workplace and commerce furniture: job stations (click to clock in), shop
 * fixtures, and mall/office/hawker decor. Owned by the economy feature.
 *
 * Stations can be bought for your own rooms too, so a player can run a cafe
 * at home -- the daily shift cap applies wherever you work.
 */
export const WORK_FURNITURE: Record<string, FurnitureDef> = defineFurniture('work', {
  barista_station: {
    label: 'Barista Station',
    description: 'Espresso, tea sock and a tin of Milo. Click to work a shift as a Kopi Barista.',
    price: 1200,
    solid: true,
    height: 1.3,
    interaction: { type: 'job', job: 'barista' },
  },
  office_desk: {
    label: 'Office Desk',
    description: 'A desk with a humming computer. Click to work a shift as an Office Clerk.',
    price: 450,
    solid: true,
    height: 1.2,
    interaction: { type: 'job', job: 'clerk' },
  },
  cash_register: {
    label: 'Cash Register',
    description: 'Ka-ching! Click to work a shift as a Mall Cashier.',
    price: 600,
    solid: true,
    height: 1.2,
    interaction: { type: 'job', job: 'cashier' },
  },
  hawker_stall: {
    label: 'Hawker Stall',
    description: 'Wok, steamer and a big menu board. Click to work a shift as a Hawker Chef.',
    price: 900,
    solid: true,
    height: 2,
    interaction: { type: 'job', job: 'chef' },
  },
  shop_counter: {
    label: 'Shop Counter',
    description: 'Put one in your shop front so visitors can browse what you sell.',
    price: 300,
    solid: true,
    height: 1,
    interaction: { type: 'shop' },
  },
  mall_directory: {
    label: 'Mall Directory',
    description: 'Every player shop in Kopi Kaki. Click to open the Marketplace.',
    price: 0,
    solid: true,
    height: 1.8,
    interaction: { type: 'shop' },
  },
  office_chair: {
    label: 'Office Chair',
    description: 'Swivels. Squeaks. Ergonomic-ish.',
    price: 120,
    solid: false,
    seat: 'facing',
    height: 0.5,
  },
  water_cooler: {
    label: 'Water Cooler',
    description: 'Where the office gossip happens.',
    price: 150,
    solid: true,
    height: 1.5,
  },
  filing_cabinet: {
    label: 'Filing Cabinet',
    description: 'Four drawers of very important paper.',
    price: 180,
    solid: true,
    height: 1.4,
  },
  shop_shelf: {
    label: 'Shop Shelf',
    description: 'Stocked with snacks, toys and knick-knacks.',
    price: 250,
    solid: true,
    height: 1.8,
  },
  clothes_rack: {
    label: 'Clothes Rack',
    description: 'The latest fashion, on hangers.',
    price: 220,
    solid: true,
    height: 1.6,
  },
  mall_bench: {
    label: 'Mall Bench',
    description: 'Rest your feet between shops.',
    price: 160,
    solid: false,
    seat: 'free',
    height: 0.45,
  },
  sale_sign: {
    label: 'SALE Sign',
    description: 'Great Singapore Sale! Everything must go.',
    price: 90,
    solid: true,
    height: 1.5,
  },
});
